import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ToastController, Content} from 'ionic-angular';
// import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';
// import * as CryptoJS from 'crypto-js';
import "rxjs/add/operator/map";
import { MysqlService } from '../../../services/mysql.service';

// import { HomePage } from '../../home/home';
import { CowDashboardPage } from '../cowDashboard/cowDashboard';
import { FarmDashboardPage } from '../../farms/farmDashboard/farmDashboard';

@Component({
  selector: 'page-updateCow',
  templateUrl: 'updateCow.html',
  // styleUrls: [ 'updateCow.scss', '../../theme/variables.scss' ]
})
export class UpdateCowPage {
  @ViewChild(Content) content: Content;
  cowDashboard: string = "general";
  detailDashboard: string = "head";
  public myreturnvalue;
  public goshala: any;
  public loading;
  public anArray: any=[];
  data;
  public type;
  public cowid;
  public cow: any = {
    // Cow_Name: String,
    // Cow_Gender: String,
    // Cow_Breed: String,
    // Cow_BirthDate: String,
    // Cow_Color: String,
    // Cow_ImagePath: String
  };

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: Http, private dbService: MysqlService, public loadingCtrl: LoadingController, public toastCtrl: ToastController) {
    this.goshala = this.navParams.get('goshala');
    this.type = this.navParams.get('type');
    if(this.navParams.get('cow') !== undefined  ){
    this.cow = this.navParams.get('cow');
    // this.getCow();
    // this.cowDashboard = this.navParams.get('cowDashboard');
    // this.detailDashboard = this.navParams.get('detailDashboard');
    
    // console.log(this.navParams.get('farmDashboard'));
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddCowPage');
  }

  // addNewCow(cow){
  //   this.myApp.addCow(cow);
  //   this.navCtrl.push(FarmDashboardPage, {goshala: this.goshala});
  // }

// detectChanges() {
//     this.cdr.detectChanges();
//   }

// clearCache(){
//       this.cache.clear();
//       localStorage.clear();
//     }

  update(){
        this.content.resize();
    } 

  async presentLoading() {
    this.loading = await this.loadingCtrl.create({
      content: 'Loading Data, please wait..',
    });
    return await this.loading.present();  
  }

  showToast() {
    if(this.type === 'update'){
    const toast = this.toastCtrl.create({
      message: 'Cow Info Updated...',
      duration: 3000
      // showCloseButton: true,
      // closeButtonText: 'Ok'
    });
    toast.present();
    }
    if(this.type === 'add'){
    const toast = this.toastCtrl.create({
      message: 'Cow Added...',
      duration: 3000
      // showCloseButton: true,
      // closeButtonText: 'Ok'
    });
    toast.present();
    }
  }

    getCow(){
    this.presentLoading()
    this.dbService.fetchDataV2("select * from cows where id = " + this.cow.id)
      .map(res => res.json())
      .subscribe(res => {
        this.goshala=res.data[0];
        console.log(this.goshala)
        // this.getCowPens();
        this.loading.dismiss();
        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
      });
  }

  executeCommand(cow){
    if(this.type === 'update'){
      this.updateCow(cow);
    }
    else if(this.type === 'add'){
      this.addCow(cow);
    } 
  }

  addCow(cow){
    this.presentLoading();
    
    this.dbService.fetchDataV2("INSERT INTO cows (goshala_id,name,tattooNumber,image,gender,age,breed,pen,type,source,status,birthDate,color,damNumber,sireNumber,purpose,hornExisting,hornColor,hornSize,hornShape,leftHornOrientation,rightHornOrientation,earLength,earOrientation,headLength,poll,peculiarHeadCharacter,hump,dewlap,navelFlap,penisSheathFlap,temperament,bodySize,chestGirth,bodyLength,heightAtWithers,tailLength,birthWeight,sixMonthWeight,twelveMonthWeight,twentyFourMonthWeight,firstCalvingWeight,coatColor,skinColor,muzzleColor,eyelidsColor,hoofsColor,tailSwitchColor,udderShape,frontUdderSize,rearUdderSize,teatShape,teatTipShape,milkVein,shaiwal,gir,hfBreed,jersey,otherBreeds,daysFirstMountingMale,ageFirstMatingMale,monthsFirstEstrusFemale,daysEstrousCycleFemale,hoursEstrusDurationFemale,monthsFirstMatingFemale,monthsFirstCalvingFemale,daysCalvingToConceptionFemale,numberConceptionsFemale,daysCalvingIntervalFemale,daysGestationLengthFemale,numberCalvingFemale,heatTolerance,workType,workCapacity,averageHoursWorkDay,handlingEase,nervousLevel,twinning,dystocia,placentaRetention,abortion,stillBirth,postGestationalMortality,otherAbnormalties,otherComments) VALUES (" + this.goshala.id + ", '" + cow.name + "', '" + cow.tattooNumber + "', '" + cow.image + "', '" + cow.gender + "', '" + cow.age + "', '" + cow.breed + "', '" + cow.pen + "', '" + cow.type + "', '" + cow.source + "', '" + cow.status + "', '" + cow.birthDate + "', '" + cow.color + "', '" + cow.damNumber + "', '" + cow.sireNumber + "', '" + cow.purpose + "', '" + cow.hornExisting + "', '" + cow.hornColor + "', '" + cow.hornSize + "', '" + cow.hornShape + "', '" + cow.leftHornOrientation + "', '" + cow.rightHornOrientation + "', '" + cow.earLength + "', '" + cow.earOrientation + "', '" + cow.headLength + "', '" + cow.poll + "', '" + cow.peculiarHeadCharacter + "', '" + cow.hump + "', '" + cow.dewlap + "', '" + cow.navelFlap + "', '" + cow.penisSheathFlap + "', '" + cow.temperament + "', '" + cow.bodySize + "', '" + cow.chestGirth + "', '" + cow.bodyLength + "', '" + cow.heightAtWithers + "', '" + cow.tailLength + "', '" + cow.birthWeight + "', '" + cow.sixMonthWeight + "', '" + cow.twelveMonthWeight + "', '" + cow.twentyFourMonthWeight + "', '" + cow.firstCalvingWeight + "', '" + cow.coatColor + "', '" + cow.skinColor + "', '" + cow.muzzleColor + "', '" + cow.eyelidsColor + "', '" + cow.hoofsColor + "', '" + cow.tailSwitchColor + "', '" + cow.udderShape + "', '" + cow.frontUdderSize + "', '" + cow.rearUdderSize + "', '" + cow.teatShape + "', '" + cow.teatTipShape + "', '" + cow.milkVein + "', '" + cow.shaiwal + "', '" + cow.gir + "', '" + cow.hfBreed + "', '" + cow.jersey + "', '" + cow.otherBreeds + "', '" + cow.daysFirstMountingMale + "', '" + cow.ageFirstMatingMale + "', '" + cow.monthsFirstEstrusFemale + "', '" + cow.daysEstrousCycleFemale + "', '" + cow.averageHoursWorkDay + "', '" + cow.monthsFirstMatingFemale + "', '" + cow.monthsFirstMatingFemale + "', '" + cow.daysCalvingToConceptionFemale + "', '" + cow.numberConceptionsFemale + "', '" + cow.daysCalvingIntervalFemale + "', '" + cow.daysGestationLengthFemale + "', '" + cow.numberCalvingFemale + "', '" + cow.heatTolerance + "', '" + cow.workType + "', '" + cow.workCapacity + "', '" + cow.averageHoursWorkDay + "', '" + cow.handlingEase + "', '" + cow.nervousLevel + "', '" + cow.twinning + "', '" + cow.dystocia + "', '" + cow.placentaRetention + "', '" + cow.abortion + "', '" + cow.stillBirth + "', '" + cow.postGestationalMortality + "', '" + cow.otherAbnormalties + "', '" + cow.otherComments + "')")
      .map(res => res.json())
      .subscribe(res => {
        // let farmDashboard: string = "cows";
        this.loading.dismiss();
        // this.clearCache();
        // this.getCow();
        // this.update();

        this.navCtrl.push(FarmDashboardPage,{goshala: this.goshala, farmDashboard: 'cows'});
        this.showToast();
          
        // this.tables=res.data;

        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
        // this.update();
      });
  }

  updateCow(cow){
    this.presentLoading();
    
    this.dbService.fetchDataV2("update cows set name = '" + cow.name + "', tattooNumber = '" + cow.tattooNumber + "', gender = '" + cow.gender + "', age = " + cow.age + ", breed = '" + cow.breed + "', pen = " + cow.pen + ", type = '" + cow.type + "', source = '" + cow.source + "', status = '" + cow.status + "', birthDate = '" + cow.birthDate + "', color = '" + cow.color + "', damNumber = '" +  cow.damNumber + "', sireNumber = '" +  cow.sireNumber + "', purpose = '" +  cow.purpose + "', hornExisting = '" +  cow.hornExisting + "', hornColor = '" +  cow.hornColor + "', hornSize = " +  cow.hornSize + ", hornShape = '" +  cow.hornShape + "', leftHornOrientation = '" +  cow.leftHornOrientation + "', rightHornOrientation = '" +  cow.rightHornOrientation + "', earLength = " +  cow.earLength + ", earOrientation = '" +  cow.earOrientation + "', headLength = " +  cow.headLength + ", poll = '" +  cow.poll + "', peculiarHeadCharacter = '" +  cow.peculiarHeadCharacter + "', hump = '" +  cow.hump + "', dewlap = '" +  cow.dewlap + "', navelFlap = '" +  cow.navelFlap + "', penisSheathFlap = '" +  cow.penisSheathFlap + "', temperament = '" +  cow.temperament + "', bodySize = '" +  cow.bodySize + "', chestGirth = " +  cow.chestGirth + ", bodyLength = " +  cow.bodyLength + ", heightAtWithers = " +  cow.heightAtWithers + ", tailLength = " +  cow.tailLength + ", birthWeight = " +  cow.birthWeight + ", sixMonthWeight = " +  cow.sixMonthWeight + ", twelveMonthWeight = " +  cow.twelveMonthWeight + ", twentyFourMonthWeight = " +  cow.twentyFourMonthWeight + ", firstCalvingWeight = " +  cow.firstCalvingWeight + ", coatColor = '" +  cow.coatColor + "', skinColor = '" +  cow.skinColor + "', muzzleColor = '" +  cow.muzzleColor + "', eyelidsColor = '" +  cow.eyelidsColor + "', hoofsColor = '" +  cow.hoofsColor + "', tailSwitchColor = '" +  cow.tailSwitchColor + "', udderShape = '" +  cow.udderShape + "', frontUdderSize = '" +  cow.frontUdderSize + "', rearUdderSize = '" +  cow.rearUdderSize + "', teatShape = '" +  cow.teatShape + "', teatTipShape = '" +  cow.teatTipShape + "', milkVein = '" +  cow.milkVein + "', shaiwal = " +  cow.shaiwal + ", gir = " +  cow.gir + ", hfBreed = " +  cow.hfBreed + ", jersey = " +  cow.jersey + ", otherBreeds = '" +  cow.otherBreeds + "', daysFirstMountingMale = " +  cow.daysFirstMountingMale + ", ageFirstMatingMale = " +  cow.ageFirstMatingMale + ", monthsFirstEstrusFemale = " +  cow.monthsFirstEstrusFemale + ", daysEstrousCycleFemale = " +  cow.daysEstrousCycleFemale + ", hoursEstrusDurationFemale = " +  cow.hoursEstrusDurationFemale + ", monthsFirstMatingFemale = " +  cow.monthsFirstMatingFemale + ", monthsFirstCalvingFemale = " +  cow.monthsFirstCalvingFemale + ", daysCalvingToConceptionFemale = " +  cow.daysCalvingToConceptionFemale + ", numberConceptionsFemale = " +  cow.numberConceptionsFemale + ", daysCalvingIntervalFemale = " +  cow.daysCalvingIntervalFemale + ", daysGestationLengthFemale = " +  cow.daysGestationLengthFemale + ", numberCalvingFemale = " +  cow.numberCalvingFemale + ", heatTolerance = '" +  cow.heatTolerance + "', workType = '" +  cow.workType + "', workCapacity = '" +  cow.workCapacity + "', averageHoursWorkDay = " +  cow.averageHoursWorkDay + ", handlingEase = '" +  cow.handlingEase + "', nervousLevel = '" +  cow.nervousLevel + "', twinning = '" +  cow.twinning + "', dystocia = '" +  cow.dystocia + "', placentaRetention = '" +  cow.placentaRetention + "', abortion = '" +  cow.abortion + "', stillBirth = '" +  cow.stillBirth + "', postGestationalMortality = '" +  cow.postGestationalMortality + "', otherAbnormalties = '" +  cow.otherAbnormalties + "', otherComments = '" +  cow.otherComments + "' where id = " + cow.id)
      .map(res => res.json())
      .subscribe(res => {
        // let farmDashboard: string = "cows";
        this.loading.dismiss();
        // this.clearCache();
        this.getCow();
        // this.update();

        this.navCtrl.push(CowDashboardPage,{goshala: this.goshala, cow: this.cow});
        this.showToast();
          
        // this.tables=res.data;

        }, error => {
        alert("FAILED, to fetch from php : "+ error);
        this.myreturnvalue = "Error : " + error;
        console.log(this.myreturnvalue)
        this.loading.dismiss();
        // this.update();
      });
  }

  // addFeilds(){
  //   var container = document.getElementById("container");
  //   // Clear previous contents of the container
  //   while (container.hasChildNodes()) {
  //       container.removeChild(container.lastChild);
  //   }
  //   container.appendChild(document.createTextNode("Member"));
  //   var input = document.createElement("ion-input");
  //   input.type = "text";
  //   input.name = "member";
  //   container.appendChild(input);
  //   // Append a line break 
  //   container.appendChild(document.createElement("br"));
  // }

   goTo(){
   console.log('this.anArray',this.anArray);
   this.data=true;
   }
   Add(){
   this.anArray.push({'value':''});
   }
}



// WEBPACK FOOTER //
// ./src/pages/cows/updateCow/updateCow.ts